import { render, staticRenderFns } from "./viewResumeDialogStudent.vue?vue&type=template&id=d15b5306&scoped=true"
import script from "./viewResumeDialogStudent.vue?vue&type=script&lang=js"
export * from "./viewResumeDialogStudent.vue?vue&type=script&lang=js"
import style0 from "./viewResumeDialogStudent.vue?vue&type=style&index=0&id=d15b5306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15b5306",
  null
  
)

export default component.exports